export function average(values = []) {
  if (!values.length) return 0;
  return values.reduce((acc, v) => acc + Number(v || 0), 0) / values.length;
}

export function deriveZoneGap(zone) {
  const currIdx = zone.levels.indexOf(zone.current);
  const tgtIdx = zone.levels.indexOf(zone.target);
  if (currIdx < 0 || tgtIdx < 0) return 0;
  return Math.max(0, tgtIdx - currIdx);
}

export function deriveRadarState(radar, period, seriesAId, seriesBId) {
  const seriesPool = radar.seriesByPeriod[period] || [];
  const fallbackA = seriesPool[0] || { id: "", label: "", values: [] };
  const fallbackB = seriesPool[1] || fallbackA;

  const a = seriesPool.find((s) => s.id === seriesAId) || fallbackA;
  const b = seriesBId === "__target"
    ? { id: "__target", label: "Role target", values: radar.target }
    : (seriesPool.find((s) => s.id === seriesBId) || fallbackB);

  const avgA = average(a.values);
  const avgB = average(b.values);
  const targetAvg = average(radar.target);
  const gapPct = targetAvg > 0 ? Math.round((avgA / targetAvg) * 100) : 0;

  return {
    seriesPool,
    a,
    b,
    avgA,
    avgB,
    delta: avgA - avgB,
    gapPct,
  };
}

export function deriveTrendSummary(trend = []) {
  if (!trend.length) return { now: 0, prev: 0, delta: 0, max: 10 };
  const now = Number(trend[trend.length - 1].score || 0);
  const prev = Number(trend[trend.length - 2]?.score || now);
  return { now, prev, delta: now - prev, max: 10 };
}

export function findMemberDetail(team, memberId) {
  const explicit = team.memberDetails[memberId];
  if (explicit) return explicit;
  const member = (team.members || []).find((m) => m.id === memberId);
  if (!member) return null;
  return {
    lastReview: "Apr 18",
    currentStage: member.current,
    targetStage: member.target,
    stageProgress: Math.max(20, Math.min(95, member.goalPct || 50)),
    parameterScores: [
      { name: "Technical depth", curr: 3.8, prev: 3.6, hist: [3.2, 3.4, 3.5, 3.6, 3.8] },
      { name: "System thinking", curr: 3.6, prev: 3.4, hist: [3.0, 3.1, 3.2, 3.4, 3.6] },
      { name: "Communication", curr: 3.5, prev: 3.3, hist: [3.0, 3.1, 3.2, 3.3, 3.5] },
    ],
    cadenceGoals: {
      weekly: [
        { title: "Weekly execution checkpoint", kpi: "priority items closed", progress: 70, approved: false },
      ],
      monthly: [
        { title: "Monthly delivery target", kpi: "planned milestones", progress: member.goalPct || 60, approved: false },
      ],
      quarterly: [
        { title: "Quarterly growth plan", kpi: "manager sign-off", progress: Math.max(20, member.goalPct - 10), approved: false },
      ],
      yearly: [
        { title: "Yearly capability objective", kpi: "promotion rubric readiness", progress: 25, approved: false },
      ],
    },
  };
}
